import { render, staticRenderFns } from "./PharmaceuticalAdd.vue?vue&type=template&id=7f316dd8&scoped=true&"
import script from "./PharmaceuticalAdd.vue?vue&type=script&lang=js&"
export * from "./PharmaceuticalAdd.vue?vue&type=script&lang=js&"
import style0 from "./PharmaceuticalAdd.vue?vue&type=style&index=0&id=7f316dd8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f316dd8",
  null
  
)

export default component.exports